import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let gaInitialized = false;

export function initGA() {
  if (GA_ID && !gaInitialized) {
    ReactGA.initialize(GA_ID);
    gaInitialized = true;
  }
}

export function trackPageView(page) {
  if (page.startsWith("/admin")) return;
  if (gaInitialized) {
    ReactGA.send({ hitType: "pageview", page });
  }
}
